export default "__VITE_ASSET__BeCvC6zD__"